import React from 'react';
import CourseCart from '../CourseCart/CourseCart';
import Header from '../Header/Header';

const Home = () => {
    return (
        <div>
            <CourseCart />
        </div>
    );
};

export default Home;